module.exports = __webpack_public_path__ + "img/social.80d9c069.svg";